"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportShort = void 0;
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const i18n_1 = require("../../../i18n");
const store_1 = require("../../../store");
const DataGrid_1 = require("../components/DataGrid");
const ImageWithTitle_1 = require("../components/ImageWithTitle");
const SplitView_1 = require("../components/SplitView");
const TitleBar_1 = require("../components/TitleBar");
const DataExtractor_1 = require("../DataExtractor");
const pdfTheme_1 = require("../pdfTheme");
const ReportHelpers_1 = require("../ReportHelpers");
const ReportBase_1 = require("./ReportBase");
class ReportShort extends ReportBase_1.ReportBase {
    constructor(poles) {
        super(poles);
    }
    buildPDF() {
        const singleColumnWidth = (pdfTheme_1.pdfTheme.page.width - SplitView_1.SPLIT_VIEW_COLUMN_GAP) / 2;
        this.poles.forEach((pole, i) => {
            const job = store_1.AppStore.Tag.get(pole.jobId);
            const fullImages = [];
            const fieldNodes = [];
            const tagArr = [];
            const leftPanel = [];
            const rightPanel = [];
            this.nodes.push(new TitleBar_1.TitleBar(pole.title || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE), job.name, i + 1, this.poles.length, i === 0 ? 'none' : 'before'));
            rightPanel.push(new DataGrid_1.DataGrid(tagArr, 2));
            // Data grid of items outside of sub forms
            pole.forEachField((field) => {
                if (field.parent.parent == null) {
                    if (field.hasValue() &&
                        field.schema.type !== core_api_1.IkeFieldType.FORM &&
                        field.schema.type !== core_api_1.IkeFieldType.IMAGE &&
                        field.schema.type !== core_api_1.IkeFieldType.TRUE_SIZE) {
                        const extractedValue = DataExtractor_1.DataExtractor.createPrintableValue(field);
                        tagArr.push([extractedValue.title, extractedValue.value]);
                    }
                    if (field instanceof core_shared_1.CollectionModelFieldSubForm) {
                        fieldNodes.push(...(0, ReportHelpers_1.extractSubforms)(pole, field, this.images, 2));
                    }
                    if (field instanceof core_shared_1.CollectionModelFieldTrueSize) {
                        const captures = field.getCaptures();
                        captures.forEach(capture => {
                            if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                                if ((0, ReportHelpers_1.hasUserMeasurement)(pole, capture.objectId)) {
                                    const imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                                    this.images[imageReferenceString] = (0, ReportHelpers_1.compositeURL)(pole, capture);
                                    fullImages.push([field.schema.displayName, imageReferenceString]);
                                }
                            }
                        });
                    }
                }
            });
            if (fullImages[0]) {
                leftPanel.push(new ImageWithTitle_1.ImageWithTitle(fullImages[0][0], { reference: fullImages[0][1] }, { width: singleColumnWidth }));
            }
            fieldNodes.forEach((fieldNode, j) => {
                if (j % 2 === 0) {
                    leftPanel.push(fieldNode);
                }
                else {
                    rightPanel.push(fieldNode);
                }
            });
            this.nodes.push(new SplitView_1.SplitView(leftPanel, rightPanel));
        });
    }
}
exports.ReportShort = ReportShort;
//# sourceMappingURL=ReportShort.js.map